<template>
  <v-container class="physical-effort">
    <v-row>
      <v-col>
        <h5>Physical effort</h5>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="physical-effort--card">
          <span class="icon">
            <img src="@/assets/water_glasses.png" width="20"/>
          </span>
          <span class="value">{{efforts.watersGlassNumber}}</span>
          <span class="target">{{efforts.watersGlassNumberGoal}}</span>
          <span class="indicator" :style="indicators.waterGlass"></span>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="physical-effort--card">
          <span class="icon">
            <img src="@/assets/sneakers.png" width="30" />
          </span>
          <span class="value">{{efforts.stepsNumber}}</span>
          <span class="target">{{efforts.stepsNumberGoal}}</span>
          <span class="indicator" :style="indicators.steps"></span>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="physical-effort--card">
          <span class="icon">
            <img src="@/assets/scale.png" width="23" />
          </span>
          <span class="value">{{efforts.weight}} <small>lbs</small></span>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="physical-effort--card">
          <span class="icon">
            <img src="@/assets/heart_pulse.png" width="28" />
          </span>
          <span class="value">{{summedEfforts}} min</span>
          <span class="line" v-if="efforts.effortLow"><b>{{efforts.effortLow}} min</b> - Low</span>
          <span class="line" v-if="efforts.effortMedium"><b>{{efforts.effortMedium}} min</b> - Medium</span>
          <span class="line" v-if="efforts.effortHigh"><b>{{efforts.effortHigh}} min</b> - High</span>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: 'PhysicalEffort',
  components: {
  },
  props: {
    efforts: {
      type: Object,
      default: function() {
        return {
          watersGlassNumber: 0,
          watersGlassNumberGoal: 0,
          stepsNumber: 0,
          stepsNumberGoal: 0,
          weight: 0
        }
      }
    }
  },
  data: () => {
    return {
      viewedYear: 0,
      viewedMonth: 0
    }
  },
  computed: {
    indicators() { // create progress bars with pseudoelements and css --width variable which can be used by ::after 
      let tmp = {}
      if (this.efforts.watersGlassNumberGoal > 0) {
        let waterGlass = this.efforts.watersGlassNumber / this.efforts.watersGlassNumberGoal * 100
        tmp.waterGlass = "--weight:"+ (waterGlass > 100 ? 100 : waterGlass) + "%"
      }
      if (this.efforts.stepsNumberGoal > 0) {
        let steps = this.efforts.stepsNumber / this.efforts.stepsNumberGoal * 100
        tmp.steps = "--weight:"+ (steps > 100 ? 100 : steps) + "%"
      }
      return tmp
    },
    summedEfforts() {
      let numericalEfforts = [this.efforts.effortLow, this.efforts.effortMedium, this.efforts.effortHigh]
      let numOr0 = n => isNaN(n) ? 0 : n
      return numericalEfforts.reduce((a, b) => 
        numOr0(a) + numOr0(b)
      )
    }
  }
}
</script>
<style lang="scss" scoped>
  .physical-effort {
    padding: 0px;
    h5 {
      padding: 0;
      color: $bh-gray--2;
    }
    .col {
      padding: 8px 12px;
    }
    &--card {
      background: $bh-blue--4;
      border-radius: 8px;
      padding: 8px;
      display: flex;
      flex-wrap: wrap;
      .icon {
        width: 35px;
        img {
          max-width: 30px;
        }
      }
      .value {
        flex-grow: 1;
        padding-left: 0px;
        font-size: 1.571425rem;
        line-height: 1.3;
        font-weight: bold;
        color: $bh-blue;
        small {
          font-size: 0.7em;
        }
      }
      .target {
        width: 40px;
        text-align: right;
        color: $bh-blue;
        font-weight: bold;
        font-size: 0.85714rem;
        align-self: center;
        line-height: 1;
        padding-top: 2px;
      }
      .line {
        width: 100%;
        color: $bh-blue;
        font-size: 0.85714rem;
        b {
          font-weight: 500
        }
      }
      .indicator {
        width: 100%;
        background: $bh-white;
        height: 6px;
        border-radius: 6px;
        margin-top: 6px;
        position: relative;
        &::after {
          content:"";
          position: absolute;
          left: 0;
          top:0;
          height: 6px;
          border-radius: 6px;
          background: $bh-blue;
          width: var(--weight);
          -webkit-transition-duration: 100ms;
          -moz-transition-duration: 100ms;
          -ms-transition-duration: 100ms;
          -o-transition-duration: 100ms;
          transition-duration: 100ms;
          
        }
      }
    }
  }
</style>